import { Component, OnInit, inject } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Survey } from 'src/app/models/survey';
import { ACTIONS } from 'src/app/shared/constants/general-constants';
import { NgxGenericModalComponent } from 'src/app/shared/ui/ngx-generic-modal/ngx-generic-modal.component';
import { SharedModule } from '../../../shared/shared.module';
import { DeleteSurveys, LoadSurveys, ReloadSurveys, SurveysState } from '../redux';
import { EditSurveyComponent } from './edit-survey/edit-survey.component';
import { ViewSurveyComponent } from './view-survey/view-survey.component';

@Component({
  selector: 'app-surveys',
  templateUrl: './surveys.component.html',
  styleUrls: ['./surveys.component.css'],
  imports: [SharedModule],
  standalone: true
})
export class SurveysComponent implements OnInit {
  public survey$: Observable<any[]> = inject(Store).select(SurveysState.surveys);
  private unsubscribe = new Subject<void>();

  public tableData;
  public showActions = [ACTIONS.CREATE, ACTIONS.EDIT, ACTIONS.CLONE, ACTIONS.DELETE];

  constructor(
    private store: Store,
    private dialogService: NbDialogService
  ) {
    if (!this.store.selectSnapshot(SurveysState.surveys)) {
      this.store.dispatch(LoadSurveys);
    }
  }

  public ngOnInit() {
    this.survey$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.tableData = data));
  }

  public clickedButton($event) {
    if ($event.action === ACTIONS.REFRESH) {
      this.tableData = undefined;
      this.store.dispatch(ReloadSurveys);
    }
    if ($event.action === ACTIONS.CREATE) {
      this.dialogService.open(EditSurveyComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          action: $event.action,
          survey: new Survey()
        }
      });
    }
    if ($event.action === ACTIONS.CLONE) {
      const survey: Survey = $event.data;
      this.dialogService.open(EditSurveyComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          action: $event.action,
          survey: Survey.clone(survey)
        }
      });
    }
    if ($event.action === ACTIONS.VIEW) {
      const survey: Survey = $event.data;
      this.dialogService.open(ViewSurveyComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          survey: Survey.copy(survey)
        }
      });
    }
    if ($event.action === ACTIONS.EDIT) {
      const survey: Survey = $event.data;
      this.dialogService.open(EditSurveyComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          action: $event.action,
          survey: Survey.copy(survey)
        }
      });
    }
    if ($event.action === ACTIONS.DELETE) {
      const survey: Survey = $event.data;
      this.dialogService
        .open(NgxGenericModalComponent, {
          closeOnEsc: false,
          closeOnBackdropClick: false,
          context: {
            title: $localize`Are you sure you want to delete Survey`,
            message: survey.survey_id + ' - ' + survey.survey_name
          }
        })
        .onClose.subscribe((data) => {
          if (data === true) {
            const surveyToDelete = Survey.copy(survey);
            surveyToDelete.deleted = true;
            this.store.dispatch(new DeleteSurveys(surveyToDelete, true));
          }
        });
    }
  }
}
